import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./About.css";
import Scrollbar from "smooth-scrollbar";
import sal from "sal.js";
import "../../node_modules/sal.js/dist/sal.css";

function About() {

  useEffect(() => {
    sal();
    var options = {
      damping: 0.1,
    };
    Scrollbar.init(document.querySelector("#my-scrollbar"), options);
  });

  return (
    <div id="my-scrollbar">
      <Navbar />
      <div className="about">
        <div className="aboutus__intro">
          <p>About Us</p>
          <h1>
            We're building something extra special
            <span style={{ fontSize: 25 }}>&#9632;</span>
          </h1>
          <h6>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            varius enim in eros elementum tristique
          </h6>
        </div>

        <div className="team__mission"></div>

        <div className="meet__our__team">
          <h2>Meet Our Team</h2>
          <div className="container">
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/ytP9VP86DItizVX2YNA-xTYzV09IS7rh4WexVp7eilIcfHmm74B7odbcwD5DTXmL0PF42i2wnRKSFPBHlmSjCblWHDCD2oD1oaM1CGFcSd48VBKJfsCi4bS170PKxGwji8CPmehwPw=w200-h247-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Lily-Grace Colley</p>
              <p className="card__desc">Founder</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/oUUiPB9sq3ACq4bUaRmo8pgvC4FUpRRrQKcGIBSOsafawZfRpF1vruFeYt6uCfL6wGDQyvOi6Ez9Bpf1Fb7APKjIyVsft7FLGR6QqdRFTiceNQBm1In9aZyrXp33cZi9pUNqjHASdA=s170-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Murray Reeve</p>
              <p className="card__desc">CEO</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/pZwZJ5HIL5iKbA91UGMUIPR0VJWa3K0vOGzDZmY6wU3EJBUdfsby3VEyxU162XxTyOyP3D154tjkr-4Jgcx8lygYUR8eB-jVmld4dsHi1c-mE_A8jKccseAG7bdEwVrcuuk6ciNtSw=s170-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Bianca Serrano</p>
              <p className="card__desc">Designer</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/pZwZJ5HIL5iKbA91UGMUIPR0VJWa3K0vOGzDZmY6wU3EJBUdfsby3VEyxU162XxTyOyP3D154tjkr-4Jgcx8lygYUR8eB-jVmld4dsHi1c-mE_A8jKccseAG7bdEwVrcuuk6ciNtSw=s170-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Bianca Serrano</p>
              <p className="card__desc">Developer</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/pZwZJ5HIL5iKbA91UGMUIPR0VJWa3K0vOGzDZmY6wU3EJBUdfsby3VEyxU162XxTyOyP3D154tjkr-4Jgcx8lygYUR8eB-jVmld4dsHi1c-mE_A8jKccseAG7bdEwVrcuuk6ciNtSw=s170-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Bianca Serrano</p>
              <p className="card__desc">HR Head</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="card">
              <img
                src="https://lh3.googleusercontent.com/pZwZJ5HIL5iKbA91UGMUIPR0VJWa3K0vOGzDZmY6wU3EJBUdfsby3VEyxU162XxTyOyP3D154tjkr-4Jgcx8lygYUR8eB-jVmld4dsHi1c-mE_A8jKccseAG7bdEwVrcuuk6ciNtSw=s170-no"
                alt="Person"
                className="card__image"
              />
              <p className="card__name">Bianca Serrano</p>
              <p className="card__desc">Developer</p>

              <ul className="social-icons">
                <li>
                  <a href="#">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa fa-codepen"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default About;
